import { render, staticRenderFns } from "./ProductVariantFeedbackModal.vue?vue&type=template&id=afdbc030"
import script from "./ProductVariantFeedbackModal.vue?vue&type=script&lang=js"
export * from "./ProductVariantFeedbackModal.vue?vue&type=script&lang=js"
import style0 from "./ProductVariantFeedbackModal.vue?vue&type=style&index=0&id=afdbc030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports